import { render } from "./DisconnectIntegrationProductsModal.vue?vue&type=template&id=96c25990"
import script from "./DisconnectIntegrationProductsModal.vue?vue&type=script&lang=js"
export * from "./DisconnectIntegrationProductsModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__